import { render, staticRenderFns } from "./PatronAvatar.vue?vue&type=template&id=384eaeae&scoped=true&"
import script from "./PatronAvatar.vue?vue&type=script&lang=js&"
export * from "./PatronAvatar.vue?vue&type=script&lang=js&"
import style0 from "./PatronAvatar.vue?vue&type=style&index=0&id=384eaeae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "384eaeae",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MtSwitch: require('/home/bitrix/frontend/components/form/MtSwitch.vue').default})
